import { Box } from '@mui/material';
import { t } from 'i18next';

import RenderIf from '../../../../renderIf';

const InvalidReason = ({ text = '(Required)', id, className, lang }) => {
    const translationKeyRegex = /\w+\.\w+(\.\w+)*/;
    const isTextTranslationKey = RegExp(translationKeyRegex).test(text);

    return (
        <Box
            component="span"
            className={className}
            id={'quest-err-' + id}
        >
            <RenderIf isTrue={typeof text === 'string'}>
                <RenderIf isTrue={isTextTranslationKey}>{t(text)}</RenderIf>

                <RenderIf isTrue={!isTextTranslationKey}>{text}</RenderIf>
            </RenderIf>

            <RenderIf isTrue={typeof text[lang] === 'string'}>{text[lang]}</RenderIf>
        </Box>
    );
};

export default InvalidReason;
